import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TypeofPipe } from './pipes';
import { SharedFooterComponent } from './components/footer/shared-footer.component';
import { SharedHeaderComponent } from './components/header/shared-header.component';
import { NavComponent } from './components/nav/nav.component';
import { ProductItemComponent } from './components/product-item/shared-product-item.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { StoreSortComponent } from './components/store-sort/shared-store-sort.component';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ProductImageComponent } from './components/product-image/product-image.component';
import { ProductImageUploaderComponent } from './components/product-image-uploader/product-image-uploader.component';
import { AmountFormatPipe } from './pipes/amount-format.pipe';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule
    ],
    exports: [
        SharedFooterComponent,
        SharedHeaderComponent,
        NavComponent,
        StoreSortComponent,
        ProductItemComponent,
        CategoriesComponent,
        BreadcrumbComponent,
        SpinnerComponent,
        ProductImageComponent,
        ProductImageUploaderComponent,
        AmountFormatPipe
    ],
    declarations: [
        SharedFooterComponent,
        BreadcrumbComponent,
        SharedHeaderComponent,
        NavComponent,
        TypeofPipe,
        AmountFormatPipe,
        StoreSortComponent,
        ProductItemComponent,
        CategoriesComponent,
        SpinnerComponent,
        ProductImageComponent,
        ProductImageUploaderComponent
    ],
    providers: [TypeofPipe],
    entryComponents: []
})
export class SharedModule { }
